/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.32/esri/copyright.txt for details.
*/
function n(n){return n}function r(n){return n}export{r as castInstanceId,n as castStrictInstanceId};
